import React, { useState } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import FAQAddOrUpdate from "./FAQAddOrUpdate";
import PndRestApi from "src/utils/pnd/PndRestApi";
import { showNotification, successNofication } from "src/shared/components/Notification";
import { Redirect } from 'react-router-dom';
import { ERROR_MESSAGES, PAGE_TIMEOUT } from "src/utils/pnd/PndConstants";
const ModalFAQ = ({ modalShow, setModalShow, isTitle, faqData }) => {
    const [isRedirect, setIsRedirect] = useState(false);
   
    if (isRedirect) {
        window.location.reload();
        return <Redirect to="/web_app/itc/faq" />;
    }
    let Icon;

    const toggle = () => {
        setModalShow(prevState => !prevState)
    }

   const handleSubmit = async (formValues) => {
       
        try {
          formValues["type"] = formValues["type"]["value"];
          const response = await PndRestApi.AddOrUpdateFaqData(formValues);
          if (response && response.status === 200 && response.data.status === 200) {
            successNofication(
              "theme-light",
              "ltr",
              `SuccessCode: 200`,
              `Message: FAQ Details Saved Successfully`,
            );
            setTimeout(() => {
              setIsRedirect(true);
            }, PAGE_TIMEOUT);
          } else {
            showNotification(
              "theme-light",
              "ltr",
              `SuccessCode: ${response.data.status}`,
              `Message:${response.data.message}`,
            );
          }
        } catch (error) {
          console.error('Error fetching data:', error);
          showNotification(
            "theme-light",
            "ltr",
            `SuccessCode: 500`,
            ERROR_MESSAGES.tryCatchError,
          );
        } 
      };
    return (
        <div >
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName={`ltr-support`}
                className="theme-light ltr-support credit-memo-modal-form-ani">
                <div className="modal__header">
                    <button
                        className="lnr lnr-cross modal__close-btn"
                        aria-label="modal__close-btn"
                        type="button"
                        onClick={toggle}
                    />
                    {Icon}
                    <h4  className="text-modal  modal__title mt-1 text-uppercase"

                    >
                        {isTitle}
                    </h4>
                </div>
                <ModalBody className="m-0">
                    <div className="credit-memo-modal-form-ani">
                        <span className="account__logo">
                            <span
                                className="account__logo-accent text-light">
                                {/* form  */}
                                {faqData ?
                                    <FAQAddOrUpdate
                                         onSubmit={handleSubmit} faqData={faqData} 
                                    /> :
                                    <FAQAddOrUpdate
                                        onSubmit={handleSubmit}
                                    />
                                }
                            </span>
                        </span>
                    </div>

                </ModalBody>
            </Modal>


        </div>
    );
};


export default connect((state) => ({
    rtl: state.rtl,
}))(ModalFAQ);
